module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/cleaning-mobile@2x-e7b18ebe7c36034231dda3ff0f20a1ba.jpg";